import {BeneficiariesRole} from '../BeneficiariesUserType';

export class AdminUserType {
  public readonly key = 'AdminUserType';
  public readonly beneficiariesRole = BeneficiariesRole.Admin;
}
